import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, useAsync, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useConfig, useVuetify } from "@/composables";
import { useConsumerSearchStore } from "@/store";
import { getAmplitudeStore } from "@/store/amplitude";
import { getFollowerStatisticsStore } from "@/store/follower-statistics";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkProfileHeader',
  props: {
  profileId: {
    type: String,
    required: true,
  },
  showFollowers: {
    type: Boolean,
    default: false,
  },
  showFollowBtn: {
    type: Boolean,
    default: true,
  },
  size: {
    type: [String, Number],
    default: 32,
  },
  largeFollowButton: {
    type: Boolean,
    default: false,
  },
  btnFollowPosition: {
    type: String as PropType<"left" | "right">,
    default: "right",
  },
  referringComponent: {
    type: String,
    default: "",
  },
  headerIndex: {
    // Index of this element in the page layout for sending to search analytics
    type: Number,
    default: -1,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const amplitude = useAmplitude();
const config = useConfig();
const route = useRoute();
const vuetify = useVuetify();
const amplitudeStore = getAmplitudeStore(store);
const consumerSearchStore = useConsumerSearchStore();

const profile = computed(() => {
  const profilesStore = getProfilesStore(store);
  return profilesStore.profiles[props.profileId];
});

const followers = computed(() => {
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(getFollowerStatisticsStore(store).followerStatistics[props.profileId] ?? 0);
});

const isLargeAvatar = computed(() => props.size.toString() === "88");
const isCreatorShop = computed(() => route.value.name === "explore-displayName");
const isSearchPage = computed(() => route.value.name === "search");

const isMobile = computed(() => vuetify.breakpoint.xsOnly);

const fetch = async () => {
  if (isCreatorShop.value) {
    await getFollowerStatisticsStore(store).fetchFollowerStatistics(props.profileId);
  }
};
useAsync(() => fetch(), "Follower Statistics");

function onProfileClick() {
  if (props.referringComponent) {
    amplitudeStore.setReferringComponent(props.referringComponent);
  }
  if (isSearchPage.value) {
    searchAnalytics();
  }
}

function searchAnalytics() {
  const isPostSearch = route.value.query.type === "post";
  const query = route.value.query.keyword?.toString() || "";
  const postCount = consumerSearchStore.ltksFeedMap[query]?.items.length || 0;
  const profileCount = consumerSearchStore.profilesFeedMap[query]?.items.length || 0;
  const brandsCount = consumerSearchStore.brandsFeedMap[query]?.brands.length || 0;
  if (!isPostSearch) {
    amplitude?.sendExitEvent("/search/tap", {
      "click-position": props.headerIndex + 1,
      "content-id": props.profileId,
      "content-type": "profile",
      index: `${config.env}-ltk-creator-profiles`,
      page: "search-results",
      "referring-component": props.referringComponent,
      "search-experience": "matching-creator-search",
    });
  }
  amplitude?.sendExitEvent("/ltk-search-summary", {
    "referring-component": props.referringComponent,
    "post-count": postCount,
    "profile-count": profileCount,
    "brand-count": brandsCount,
    query,
  });
}

return { __sfc: true,props, store, amplitude, config, route, vuetify, amplitudeStore, consumerSearchStore, profile, followers, isLargeAvatar, isCreatorShop, isSearchPage, isMobile, fetch, onProfileClick, searchAnalytics }
}

})